import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: "home",
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./features/auth/auth-module.module").then(
        (m) => m.AuthModuleModule
      ),
  },
  {
    path: "survey",
    loadChildren: () =>
      import("./features/survey/survey.module").then((m) => m.SurveyModule),
  },
  {
    path: "home",
    loadChildren: () =>
      import("./features/home/home.module").then((m) => m.HomeModule),
  },
  {
    path: "intro",
    loadChildren: () =>
      import("./features/intro/intro.module").then((m) => m.IntroModule),
  },
  {
    path: "users",
    loadChildren: () =>
      import("./features/users/users.module").then((m) => m.UsersModule),
  },
];
@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
